import React, { useEffect, useMemo, useState } from "react";
import { Form } from "react-bootstrap";
import uuid from "react-uuid";

import styles from "./Checkbox.module.scss";

export interface CheckboxProps {
    className?: string;
    onValueChange: (value: string, checked: boolean) => void;
}
export const Checkbox: React.FC<JSX.IntrinsicElements["input"] & CheckboxProps> = ({
    children,
    className,
    value,
    checked,
    onValueChange,
    ...props
}) => {
    const [_value, _setValue] = useState(value);
    const [_checked, _setChecked] = useState(checked);

    useEffect(() => {
        _setValue(value);
    }, [value]);

    useEffect(() => {
        _setChecked(checked);
    }, [checked]);

    const _onChange = useMemo(() => {
        return (value, checked) => {
            _setValue(value);
            _setChecked(checked);
        };
    }, []);
    return (
        <Form.Check type={"checkbox"} id={uuid()} className={`${styles.checkbox} ${className ?? ""}`}>
            <Form.Check.Input
                type={"checkbox"}
                checked={_checked}
                value={_value}
                onChange={e => {
                    const value = (e.target ?? e.currentTarget)?.value;
                    const checked = (e.target ?? e.currentTarget)?.checked;

                    const onChange = onValueChange ?? _onChange;
                    onChange(value, checked);
                }}
            />
            <Form.Check.Label>{children}</Form.Check.Label>
        </Form.Check>
    );
};
